import FeedbackCollection from 'ai/components/SuperChat/FeedbackCollection/FeedbackCollection';
import { withFeedbackCollectionProps } from 'ai/viewModel/superChat/feedbackCollection/withFeedbackCollectionProps';

export default withFeedbackCollectionProps(FeedbackCollection);
